// "Wo liegt was?" — open/close the SUCHBEREICH scope dropdown. Options are up-links that swap
// #lookup-main, so there is no selection logic here. Bound to #lookup-main so it re-binds to the
// fresh scope card after every fragment swap. `up` is a global in this app — do not import it.

up.compiler('[data-material-lookup]', (root) => {
  const scope = root.querySelector('.material-lookup__scope')
  if (!scope) return // Result phase has no scope card.

  const toggle = scope.querySelector('[data-scope-toggle]')
  up.on(toggle, 'click', (event) => {
    event.preventDefault()
    scope.classList.toggle('is-open')
  })

  const onDocumentClick = (event) => {
    if (!scope.contains(event.target)) scope.classList.remove('is-open')
  }
  document.addEventListener('click', onDocumentClick)
  return () => document.removeEventListener('click', onDocumentClick)
})
